import moment from 'moment';

const NOVEMBER_MONTH_INDEX = 10;
const OCTOBER_MONTH_INDEX = 9;
const OCTOBER_START_DAY = 24;

export default function isBlackNovember() {
  const today = moment();
  const isNovember = today.month() === NOVEMBER_MONTH_INDEX;

  const isInternalTestEnvironment = process.env.REACT_APP_ENV !== 'production';
  const isOctober = today.month() === OCTOBER_MONTH_INDEX;
  const isTodayEqualOrAfterStartDay = today.date() >= OCTOBER_START_DAY;

  const isTodayAValidBlackNovemberException =
    isInternalTestEnvironment && isOctober && isTodayEqualOrAfterStartDay;

  return isNovember || isTodayAValidBlackNovemberException;
}
